import { ACTION_VARIANTS, Button, ICON_NAMES } from '@reverse-hr/design-system';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

export const ApplicationFeedbackActions = ({
  isCustomerInterested,
  onFeedbackUpdate,
}) => {
  const { t } = useTranslation(null, {
    keyPrefix: 'candidateDetails.feedback',
  });

  const changeFeedbackButtonClassName = classNames('c-app-fat-button', {
    'c-app-fat-button--positive': isCustomerInterested === true,
    'c-app-fat-button--negative': isCustomerInterested === false,
  });

  return isCustomerInterested === null ? (
    <>
      <Button
        className="c-app-fat-button c-app-fat-button--positive"
        leftIcon={ICON_NAMES.CHECK}
        onClick={() => onFeedbackUpdate(true)}
        variant={ACTION_VARIANTS.GHOST}
      >
        {t('actionYes')}
      </Button>

      <Button
        className="c-app-fat-button c-app-fat-button--negative"
        leftIcon={ICON_NAMES.CLOSE_BIG}
        onClick={() => onFeedbackUpdate(false)}
        variant={ACTION_VARIANTS.GHOST}
      >
        {t('actionNo')}
      </Button>
    </>
  ) : (
    <Button
      className={changeFeedbackButtonClassName}
      onClick={() => onFeedbackUpdate(!isCustomerInterested)}
      rightIcon={ICON_NAMES.CHEVRON_BIG_RIGHT}
      variant={ACTION_VARIANTS.GHOST}
    >
      {t('actionChangeFeedback')}
    </Button>
  );
};
